import Routerx from './router.element.js';

export default Routerx;

Routerx.define('wje-router', Routerx);
